import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { DvLineSeriesModel } from './type';

function parseSymbolDensity(chart: ExtensionAPI) {
  const ecModel = chart.getModel();
  const lineModels = ecModel.getSeriesByType('line');
  lineModels.forEach((model: DvLineSeriesModel) => {
    const data = model.getData();
    const densityLevel = model.get('dvShowSymbolStrategy');

    // 如果dvShowSymbolStrategy不为空且大于0
    // 则根据视图内数据个数动态调整showSymbol配置
    // 数据个数大于密度阈值时，不显示symbol，showSymbol为false;
    // 数据个数小于等于密度阈值时，显示symbol，showSymbol为true;
    if (densityLevel) {
      model.option.showSymbol = data.count() <= densityLevel;
    }
  });
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:beforeupdate', (ecModel, api) => {
    parseSymbolDensity(api);
  });
}
